export enum STATES {
	PLAYING = 'playing',
	PAUSED = 'paused',
	BUFFERING = 'buffering',
	IDLE = 'idle',
	COMPLETE = 'complete'
}
